import React, {FunctionComponent, LegacyRef} from 'react';
import "./info.scss";
import Content from "../Content/Content";

interface IProps {
    visibleRef: LegacyRef<HTMLParagraphElement>;
}

const Info:FunctionComponent<IProps> = ({visibleRef}) => {

    return (
        <div id={"info-panel"} className="info-container">
            <Content className="info-content">
                <h3>
                    MAGNUMBET - Pasiune pentru pariuri sportive online
                </h3>
                <p>
                    Magnumbet este o casă de pariuri online și în agenții, unde vei găsi nu doar pariuri 1X2, ci care
                    și-a propus și a reușit să ofere toate tipurile de pariuri sportive, din toate sporturile populare
                    în România - de la fotbal și tenis, la baschet, golf, rugby, handbal si multe altele.

                    Am pornit ca o rețea de agenții de jocuri din Constanța și, în câțiva ani, am reușit să ajungem la
                    peste 150 de locații în întreaga țară, cu focus pe zona Dobrogei.
                </p>

                <p ref={visibleRef}>Cotele de pariuri Magnumbet se poziționează în topul pieței. Cu câteva mii de evenimente sportive
                    disponibile zilnic, la Magnumbet orice parior va găsi ocazii să-și folosească cunoștințele și
                    pronosticurile la pariuri pentru a le transforma în bilete câștigătoare.
                </p>

                <p>Pentru plăcerea de a paria, Magnumbet ți-a pregătit cote de top și ponturi la pariuri bine calculate,
                    ce îți pot aduce câștiguri spectaculoase în fiecare zi.
                </p>

                <h3>
                    Ponturi pariuri pentru începători și pasionați
                </h3>

                <p>
                    Știm că pentru pariorul român nimic nu e mai atrăgător decât Clasamentul Ligii 1 sau Liga
                    Campionilor, dar la Magnumbet am făcut mai interesantă oferta de evenimente prin numărul mare de
                    sporturi, campionate și opțiuni de pariere oferite, dar și prin seria de promoții și oferte speciale
                    la pariuri online.
                </p>

                <p>
                    Pe lângă Freebetul de 500 lei pe care ți l-am pus deoparte în Bonusul de bun-venit, beneficiezi și
                    de Magnum Cota, o serie de evenimente cu cote mărite față de oferta pieței pentru rezultat final, în
                    fiecare zi. Totodată, când plasezi un pariu online cu mai multe evenimente pe bilet, Magnumbet te
                    premiază cu un câștig extra care poate ajunge până la 160% din suma mizată!
                </p>

                <h3>
                    Pariuri Sportive Live - pariază pe meciuri în desfășurare și câștigă rapid
                </h3>

                <p>
                    De ce ne plac pariurile live? Opțiunile de live betting sunt populare datorită dinamismului jocului
                    și nivelului crescut de adrenalină în timpul unui meci intens. Printr-un pariu live, pariorii au
                    posibilitatea de a miza pe evenimente sportive chiar în timp ce acestea se desfășoară. Iar la
                    Magnumbet, nu trebuie să pariezi înainte de începerea meciurilor și nici nu trebuie să aștepți până
                    la final ca să găsești pronosticuri la pariuri sportive și cote excelente care îți pot aduce
                    câștiguri foarte bune. Ca toate marile case de pariuri, pe Magnumbet vei găsi și evenimente
                    extra-sport - de pildă, poți miza și pe câștigătorii alegerilor prezidențiale de oriunde din lume
                    sau chiar pe clasamentul Eurovision.
                </p>

                <p>
                    Platforma Magnumbet este 100% securizată, reglementată și controlată, fiind licențiată de Oficiul
                    Național pentru Jocuri de Noroc. Pronosticurile și pariurile Magnumbet sunt verificate și sigure,
                    astfel încât poți paria fără griji. Plasează bilete pariuri online sau în agenții și bucură-te de
                    retrageri super rapide pe site sau într-una din sutele de locații fizice din toată țara.
                </p>
            </Content>
        </div>
    );
}

export default Info;